/*
 * @Description: 
 * @Author: yingbin
 * @Date: 2019-08-22 14:30:49
 * @LastEditTime: 2020-5-20 09:05:18
 * @LastEditors: Guojun
 */
import Vue from 'vue'
import App from './App.vue'
import router from '@/routers/router'
import store from '@/stores/index'
import '@/assets/css/base.css'
import ElementUI from 'element-ui';
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
import 'element-ui/lib/theme-chalk/index.css';
import request from '@/utils/request';
import utils from '@/utils/utils';
import modelLogin from '@/apis/modelLogin';
import axios from 'axios'
import VueClipboard from 'vue-clipboard2'
axios.defaults.withCredentials = true;
Vue.use(ElementUI);
Vue.use(mavonEditor);
Vue.use(modelLogin);
Vue.use(VueClipboard);
Vue.prototype.$post = request.post;
Vue.prototype.$get = request.get;
Vue.prototype.$axios = axios
Vue.prototype.$EventBus = new Vue()
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {

  if (to.path) {
    if (window._hmt) {
      if(utils.getEnv() == 'pro'){
        window._hmt.push(['_trackPageview', '/' + to.fullPath])
      }else{
        window._hmt.push(['_trackPageview', '/#' + to.fullPath])
      }   
    }
  }
  //百度统计
  document.title = to.meta.title;
  /** 帮助菜单 */
  if(to.path.split('/')[1] == 'help'){
    if(to.path == '/help/applyDevHelp'){
      store.state.help_menu_path = '/help/developer'
    }else{
      store.state.help_menu_path = to.path
    }
  }
  /** 控制台 */
  if(to.path.split('/')[1] == 'control'){
    let control_list = ['control','newApplication']
    if(control_list.indexOf(to.path.split('/')[1]) != -1){
      if(to.path.split('/')[2] == 'applicationManagement'){
        store.state.help_menu_path = '/control/applicationManagement'
      }else{
        store.state.help_menu_path = to.path
      }
    }
  }

  let token = utils.getCookie("TOKEN")
  const nextRoute = ['userInfo', 'newApplication', 'applicationManagement', "company"];
  if(nextRoute.indexOf(to.name) >= 0){
    if(!token || token == 'null'){
      next({
        path:'/index'
      })
      Vue.prototype.$toast(true);    //动态加载子组价
      return
    }   
  }
  next();
})
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')